import { render, staticRenderFns } from "./work_order_processing_user_revoke.vue?vue&type=template&id=4a36e7f6&scoped=true&"
import script from "./work_order_processing_user_revoke.vue?vue&type=script&lang=js&"
export * from "./work_order_processing_user_revoke.vue?vue&type=script&lang=js&"
import style0 from "./work_order_processing_user_revoke.vue?vue&type=style&index=0&id=4a36e7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36e7f6",
  null
  
)

export default component.exports